import { apiClient } from '../../../core/apiClient';
import { API_CONFIG } from '../../../core/apiConfig';
import type { ApiResponse } from '../../../shared';
import type { LC_CreateCompanyIn, LC_CreateCompanyOut } from '../types';

/**
 * Service for company creation operations
 */
class CompanyCreateService {
  /**
   * Creates a new company
   * @param input Company data to create
   * @returns ApiResponse with companyId on success or error
   * 
   * Response codes:
   * - 201: Company created successfully (returns { companyId })
   * - 400: Validation error (VALIDATION_ERROR)
   * - 409: Conflict - duplicate RUT (CONFLICT_DUPLICATE_COMPANY)
   * - 404: Holding not found for fatherCompanyId (NOT_FOUND_HOLDING)
   * - 500: Internal server error (COMPANY_CREATION_ERROR)
   */
  async create(input: LC_CreateCompanyIn): Promise<ApiResponse<LC_CreateCompanyOut>> {
    return apiClient.post<LC_CreateCompanyOut>(API_CONFIG.ENDPOINTS.COMPANY.CREATE, input);
  }
}

export const companyCreate = new CompanyCreateService();
